<template>
  <div class="modal-overlay">
    <div class="mmodal-content" style="max-width: 40vw">
      <div class="modal-header">
        <h5 class="modal-title">Add Diagnosis</h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>

      <div class="modal-body">
        <div class="form-group mb-3">
          <label>Diagnosis</label>
          <input
            v-on:keyup="onchangeHandler"
            v-model="diagnosis"
            type="text"
            class="form-control"
            name="diagnosis"
            placeholder="Diagnosis name"
          />
        </div>
        <div
          v-if="options.length"
          ref="suggestionBox"
          class="suggestion_capsule"
        >
          <div v-for="option in options" :key="option.id">
            <article @click="optionclick(option)" class="borderit spacer">
              <span class="spacer">
                {{ option.code + " - " + option.short_name }}
              </span>
              <br /><span class="min_dull">
                {{
                  option.coma_separated_code + " - " + option.long_name
                }}</span
              >
            </article>
          </div>
        </div>

        <div class="form-group mb-3">
          <label>Type</label>
          <select v-model="diagnosis_type" class="form-control">
            <option value="Primary">Primary</option>
            <option value="Secondary">Secondary</option>
          </select>
        </div>

        <div class="form-group mb-3">
          <label>Stage</label>
          <input
            v-model="diagnosis_stage"
            type="text"
            class="form-control"
            placeholder="Optional stage"
          />

          <!-- <div>
            <input
              :style="{ border: warning ? '1px solid red' : '1px solid black' }"
              ref="itemInput"
              type="text"
              autocomplete="off"
              :value="item_name"
              name="item_name"
              v-on:blur="blurHandler"
              v-on:keyup="onchangeHandler"
              class="form-control"
              placeholder="item name"
            />
            <span v-if="warning" style="font-size: 0.8em; color: red"
              >You have to pick from suggestion options</span
            >
            <input autocomplete="off" name="item_id" type="hidden" />
           
          </div> -->
          <!--  -->
        </div>

        <div class="form-group">
          <label>Note</label>
          <textarea
            v-model="note"
            class="form-control"
            rows="3"
            placeholder="Optional note..."
          ></textarea>
        </div>
      </div>

      <div class="modal-footer mt-4">
        <button
          type="button"
          class="btn btn-secondary mr-2"
          @click="closeModal"
        >
          Cancel
        </button>
        <button type="button" class="btn btn-primary" @click="submitDiagnosis">
          Save Diagnosis
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";

export default {
  name: "AddDiagnosisModal",
  props: {
    visit_id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      diagnosis: "",
      diagnosis_type: "Primary",
      diagnosis_stage: "",
      note: "",
      //
      item_name: "",
      options: [],
      warning: false,
      chosen: false,
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-add-diagnosis-modal");
    },
    async onchangeHandler(event) {
      console.log(event.target.name);

      this[event.target.name] = event.target.value;
      const url = "find_disease";
      const body = {
        search_param: event.target.value,
      };
      const suggestions = await generalApiRequest(url, "GET", body, 1);
      this.options = suggestions.data;
      console.log(suggestions);

      this.$nextTick(() => {
        const inputRect = this.$refs.itemInput.getBoundingClientRect();
        const suggestionBox = this.$refs.suggestionBox;
        if (suggestionBox) {
          suggestionBox.style.top = `${inputRect.bottom + window.scrollY}px`;
          suggestionBox.style.left = `${inputRect.left + window.scrollX}px`;
          suggestionBox.style.width = `${inputRect.width}px`;
        }
      });
    },
    optionclick(option) {
      this.chosen = true;
      this.warning = false;
      //   const nm = JsItemName(
      //     option.brand_name,
      //     option.item_strength,
      //     option.item_name
      //   );
      this.diagnosis = option.code + " - " + option.short_name;
      this.options = [];
      this.$emit("itemoption-check", option, this.Rowid);
    },

    blurHandler() {
      if (!this.chosen) {
        this.warning = true;
      } else {
        this.warning = false;
      }
      setTimeout(() => {
        this.options = [];
      }, 500);
    },
    //---------------------
    async submitDiagnosis() {
      if (!this.diagnosis.trim()) {
        alert("Diagnosis is required.");
        return;
      }

      try {
        const url = "add_diagnosis_record";
        const body = {
          visit_id: this.visit_id,
          diagnosis: this.diagnosis,
          diagnosis_type: this.diagnosis_type,
          diagnosis_stage: this.diagnosis_stage,
          note: this.note,
        };

        const res = await generalApiRequest(url, "POST", body, 1);

        if (res.status === "success") {
          this.$emit("diagnosis-added");
          this.closeModal();
        } else {
          alert("Failed to save diagnosis.");
        }
      } catch (error) {
        console.error("API error:", error);
        alert("An error occurred while saving the diagnosis.");
      }
    },
  },
};
</script>

<style scoped>
.modal-body {
  padding: 1rem;
}

.suggestion_capsule {
  border: 1px solid grey;
  border-radius: 0.2em;
  z-index: 9999;
  position: fixed;
  background-color: rgb(223, 241, 241);
  max-height: 50vh;
  overflow-y: auto;
}

.spacer {
  padding-right: 1em;
  padding-left: 1em;
}

.min_dull {
  color: grey;
  font-size: 0.8em;
}

.borderit {
  border-bottom: 1px solid rgb(184, 212, 216);
}

.borderit:hover {
  background-color: beige;
  cursor: pointer;
}
</style>
